import { Alert, Box, Card, Stack } from '@mui/material'
import { memo } from 'react'

import { Trans } from 'react-i18next'
import { COLOR_ERROR } from 'src/constants/theme'
import { questRedirectUrl } from '../../util/quest.helpers'
import { formatTicks } from '../../util/string.helpers'
import { Image } from '../shared/image'
import { Label } from '../shared/label'
import SubmitButton from '../shared/button/SubmitButton'
import Text from '../shared/text/Text'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'

const QuestCard = ({
  t,
  sx,
  id,
  title,
  description,
  amount,
  mediaUrl,
  questRewards,
  enableFulfill,
  selected,
  onFulfillQuest,
  onVerifyAndClaim,
  loading,
  error,
  symbol
}) => {
  const verified = (questRewards?.length && questRewards[0]?.verified) || false
  const errorMessage = error?.questReward
  return (
    <Card
      sx={[
        {
          width: 1,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' }
          // alignItems: { xs: 'flex-start', sm: 'normal' }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <Box
        sx={{
          p: 1,
          width: { xs: 1, sm: 180 },
          flexShrink: 0,
          position: 'relative'
        }}
      >
        <Image
          alt={title}
          src={mediaUrl}
          sx={{ aspectRatio: '1/1', borderRadius: 1.5 }}
          visibleByDefault={false}
        />
      </Box>
      <Stack
        spacing={1}
        sx={{
          flexGrow: 1,
          py: 2,
          px: 2
        }}
      >
        <Stack
          spacing={1}
          sx={{ flexGrow: 1, alignItems: { xs: 'flex-start', sm: 'normal' } }}
        >
          <Text
            color='inherit'
            variant='subtitle2'
            sx={[
              (theme) => ({
                ...theme.mixins.maxLine({ line: 2 })
              })
            ]}
            label={title}
          />
          <Text
            variant='body2'
            sx={[
              (theme) => ({
                ...theme.mixins.maxLine({ line: 2 }),
                color: 'text.secondary'
              })
            ]}
            label={description}
          />
          <Label color='primary' sx={{ width: 'fit-content' }}>
            <Trans
              i18nKey='wallet.reward'
              values={{ value: formatTicks(amount), symbol }}
            />
          </Label>
          {/* <Text
            color='inherit'
            variant='subtitle2'
            sx={{ mt: 1 }}
            label={
              <Trans
                i18nKey='wallet.reward'
                values={{ value: formatTicks(amount), symbol }}
              />
            }
          /> */}
          {verified && (
            <Alert severity='success' sx={{ mt: 0.5, py: 0, px: 1 }}>
              {t('quest.quest-completed')}
            </Alert>
          )}
        </Stack>

        {!verified && (
          <Stack spacing={1} mt={1}>
            {id === selected && errorMessage && (
              <Text color={COLOR_ERROR} label={t(errorMessage)} />
            )}
            <Box
              sx={{
                gap: 2,
                flexGrow: 1,
                display: 'flex',
                flexWrap: 'wrap',
                typography: 'caption',
                justifyContent: { xs: 'flex-start', sm: 'normal' }
              }}
            >
              <SubmitButton
                label={t('quest.fulfill-quest')}
                onClick={() => onFulfillQuest(id)}
                href={questRedirectUrl(id)}
                component='a'
                size='default'
                type='button'
                {...NAVIGATION_BLANK_PARAMS}
              />
              <SubmitButton
                label={t('quest.verify-and-claim-reward')}
                disabled={!enableFulfill[id]}
                loading={id === selected && loading}
                onClick={() => onVerifyAndClaim(id)}
                size='default'
                type='button'
              />
            </Box>
          </Stack>
        )}
      </Stack>
    </Card>
  )
}

export default memo(QuestCard)
